import * as React from "react";

const OverLappingClothes = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={175}
    height={120}
    viewBox="0 0 175 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.487}
      y={20.7664}
      width={75.5342}
      height={74.296}
      rx={19.1931}
      transform="rotate(-15.5082 0.487 20.7664)"
      fill="url(#paint0_linear_1678_15394)"
    />
    <rect
      x={0.487}
      y={20.7664}
      width={75.5342}
      height={74.296}
      rx={19.1931}
      transform="rotate(-15.5082 0.487 20.7664)"
      fill="black"
      fillOpacity={0.1}
    />
    <foreignObject x={46.7925} y={27.1991} width={93.823} height={95.7257}>
      <div
        style={{
          backdropFilter: "blur(6.42px)",
          clipPath: "url(#bgblur_0_1678_15394_clip_path)",
          height: "100%",
          width: "100%",
        }}
      />
    </foreignObject>
    <g filter="url(#filter0_i_1678_15394)" data-figma-bg-blur-radius={12.8313}>
      <rect
        x={57.2593}
        y={52.2264}
        width={59.4958}
        height={62.1206}
        rx={11.0448}
        transform="rotate(-14.166 57.2593 52.2264)"
        fill="url(#paint1_linear_1678_15394)"
      />
      <rect
        x={57.2593}
        y={52.2264}
        width={59.4958}
        height={62.1206}
        rx={11.0448}
        transform="rotate(-14.166 57.2593 52.2264)"
        fill="black"
        fillOpacity={0.1}
      />
      <rect
        x={57.7388}
        y={52.5126}
        width={58.7061}
        height={61.331}
        rx={10.65}
        transform="rotate(-14.166 57.7388 52.5126)"
        stroke="url(#paint2_linear_1678_15394)"
        strokeWidth={0.789618}
      />
      <rect
        x={57.7388}
        y={52.5126}
        width={58.7061}
        height={61.331}
        rx={10.65}
        transform="rotate(-14.166 57.7388 52.5126)"
        stroke="black"
        strokeOpacity={0.1}
        strokeWidth={0.789618}
      />
    </g>
    <foreignObject x={89.6294} y={32.5945} width={95.0051} height={96.775}>
      <div
        style={{
          backdropFilter: "blur(6.42px)",
          clipPath: "url(#bgblur_1_1678_15394_clip_path)",
          height: "100%",
          width: "100%",
        }}
      />
    </foreignObject>
    <g filter="url(#filter1_i_1678_15394)" data-figma-bg-blur-radius={12.8313}>
      <rect
        x={117.447}
        y={42.7434}
        width={59.4958}
        height={62.1206}
        rx={11.0448}
        transform="rotate(16.5247 117.447 42.7434)"
        fill="url(#paint3_linear_1678_15394)"
      />
      <rect
        x={117.447}
        y={42.7434}
        width={59.4958}
        height={62.1206}
        rx={11.0448}
        transform="rotate(16.5247 117.447 42.7434)"
        fill="black"
        fillOpacity={0.1}
      />
      <rect
        x={117.713}
        y={43.2342}
        width={58.7061}
        height={61.331}
        rx={10.65}
        transform="rotate(16.5247 117.713 43.2342)"
        stroke="url(#paint4_linear_1678_15394)"
        strokeWidth={0.789618}
      />
      <rect
        x={117.713}
        y={43.2342}
        width={58.7061}
        height={61.331}
        rx={10.65}
        transform="rotate(16.5247 117.713 43.2342)"
        stroke="black"
        strokeOpacity={0.1}
        strokeWidth={0.789618}
      />
    </g>
    <defs>
      <filter
        id="filter0_i_1678_15394"
        x={46.7925}
        y={27.1991}
        width={93.823}
        height={95.7257}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={9.87022}
          operator="erode"
          in="SourceAlpha"
          result="effect1_innerShadow_1678_15394"
        />
        <feOffset dx={-5.92213} dy={5.92213} />
        <feGaussianBlur stdDeviation={3.94809} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1678_15394"
        />
      </filter>
      <clipPath
        id="bgblur_0_1678_15394_clip_path"
        transform="translate(-46.7925 -27.1991)"
      >
        <rect
          x={57.2593}
          y={52.2264}
          width={59.4958}
          height={62.1206}
          rx={11.0448}
          transform="rotate(-14.166 57.2593 52.2264)"
        />
      </clipPath>
      <filter
        id="filter1_i_1678_15394"
        x={89.6294}
        y={32.5945}
        width={95.0051}
        height={96.775}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={9.87022}
          operator="erode"
          in="SourceAlpha"
          result="effect1_innerShadow_1678_15394"
        />
        <feOffset dx={-5.92213} dy={5.92213} />
        <feGaussianBlur stdDeviation={3.94809} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1678_15394"
        />
      </filter>
      <clipPath
        id="bgblur_1_1678_15394_clip_path"
        transform="translate(-89.6294 -32.5945)"
      >
        <rect
          x={117.447}
          y={42.7434}
          width={59.4958}
          height={62.1206}
          rx={11.0448}
          transform="rotate(16.5247 117.447 42.7434)"
        />
      </clipPath>
      <linearGradient
        id="paint0_linear_1678_15394"
        x1={16.006}
        y1={20.7664}
        x2={83.7039}
        y2={97.8757}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1678_15394"
        x1={69.4831}
        y1={52.2264}
        x2={126.426}
        y2={113.326}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1678_15394"
        x1={69.4831}
        y1={52.2264}
        x2={126.426}
        y2={113.326}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1678_15394"
        x1={129.671}
        y1={42.7434}
        x2={186.614}
        y2={103.843}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1678_15394"
        x1={129.671}
        y1={42.7434}
        x2={186.614}
        y2={103.843}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
    </defs>
  </svg>
);

export default OverLappingClothes;
